import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./store/reducers/rootReducer";
import * as serviceWorker from "./serviceWorker";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import thunk from "redux-thunk";
import { whatGEO } from "./store/actions/authActions";

import {
  reduxFirestore,
  createFirestoreInstance,
  getFirestore,
} from "redux-firestore";

import { Provider, useSelector } from "react-redux";

import {
  ReactReduxFirebaseProvider,
  getFirebase,
  isLoaded,
} from "react-redux-firebase";

import firebase, { fbConfig } from "./config/fbConfig";

const queryParams = new URLSearchParams(window.location.search);

console.log(localStorage);

if (queryParams.get('premium') === 'pF2e6G3e255e6') {
  localStorage.setItem('isPremium', true);
}
if (queryParams.get('premium') === 'remove') {
  localStorage.removeItem('isPremium');
}

//const store = createStore(rootReducer, applyMiddleware(thunk));
const options = {
  // you can also just use 'bottom center'
  position: positions.TOP_CENTER,
  timeout: 3000,
  offset: "100px",
  containerStyle: {
    zIndex: 999999999999999,
  },
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
    //reactReduxFirebase(fbConfig, {userProfile: 'users', useFirestoreForProfile: true, attachAuthIsReady: true}),
    //reduxFirestore(fbConfig) // redux bindings for firestore
    reduxFirestore(firebase, fbConfig)
  )
);
const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: true,
  attachAuthIsReady: true,
  timestampsInSnapshots: true,
};

const rrfProps = {
  firebase,
  config: Object.assign({}, fbConfig, rrfConfig),
  dispatch: store.dispatch,
  createFirestoreInstance,
};

const AuthIsLoaded = ({ children }) => {
  const auth = useSelector((state) => state.firebase.auth);
  if (!isLoaded(auth)) return <></>;
  return children;
};

store.dispatch(whatGEO());

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <AuthIsLoaded>
        <AlertProvider template={AlertTemplate} {...options}>
          <App />
        </AlertProvider>
      </AuthIsLoaded>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

//setTimeout(() => {
serviceWorker.unregister();
//}, 9000);
